import { SeatsIOSeat } from "~components/reservation/constants";

import * as Sentry from "@sentry/nextjs";

import { LineItemInput, LineItemType } from "~graphql/sdk";
import { getCategoryDataFromLabel } from "~lib/helpers";

export const seatsToLineItems = (
  seats: SeatsIOSeat[],
  type: "event" | "membership" | "release",
  oldTickets?: string[]
): LineItemInput[] => {
  getCategoryDataFromLabel;
  return seats.map(({ label, ticketType, category, objectType }, key) => {
    const { zone, section, tags } = getCategoryDataFromLabel(category.label);

    const lineItem = {
      type: LineItemType.Ticket,
      ticketTypeId: ticketType?.value || ticketType?.id,
      quantity: 1,
      seatLabel: label,
      seatZone: zone,
      seatSection: section,
      seatTags: tags,
      seatType: objectType === "Seat" ? "seat" : "generalAdmission",
      ...(oldTickets?.[key] ? { previousTicketId: oldTickets[key] } : {}),
    };

    if (!ticketType?.id && !ticketType?.value) {
      Sentry.captureException(new Error(`Ticket type is missing for seat`), {
        tags: {
          orderType: type,
          seatLabel: label,
          seatZone: zone,
          seatSection: section,
        },
        extra: {
          rawSeats: seats,
        },
      });
      console.error(`Ticket type is missing for seat`);
    }

    return lineItem;
  });
};
